import emailjs from '@emailjs/browser';



export const send_email_emailJs = async(emailBody) => await emailjs.send("service_t5qbzac", "template_7ig1pc8", emailBody, "y5d3PYumwpQdaGx32")

